var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('span',[(_vm.tooltip)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(" "+_vm._s(_vm.value)+" ")])]}}],null,false,2957596692)},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")]):_c('span',[_vm._v(_vm._s(_vm.value))])],1):_c('span',[_vm._v(_vm._s(_vm.placeholder))])
}
var staticRenderFns = []

export { render, staticRenderFns }